const Facebook = (props: { fill: string }) => {
	return (
		<>
			<path
				d="M24 12.0441C24 5.39238 18.6274 0 12 0C5.37264 0 0 5.39238 0 12.0441C0 17.6923 3.87456 22.4319 9.10128 23.7336V15.7248H6.62688V12.0441H9.10128V10.4581C9.10128 6.35879 10.9498 4.45872 14.9597 4.45872C15.72 4.45872 17.0318 4.60855 17.5685 4.75789V8.0941C17.2853 8.06424 16.7933 8.0493 16.1822 8.0493C14.2147 8.0493 13.4544 8.79748 13.4544 10.7424V12.0441H17.3741L16.7006 15.7248H13.4544V24C19.3954 23.2798 24 18.202 24 12.0441Z"
				fill={props.fill}
			/>
		</>
	);
};

export default Facebook;
